import { AuthContext } from "../context/AuthContextTest.js"
import { useContext } from "react"

export const useAuthContext = () => {
  const context = useContext(AuthContext)
  console.log(context,'context')

  if(!context) {
    throw Error('useAuthContext must be used inside an AuthContextProvider')
  }

  return context
}